import { render, staticRenderFns } from "./FormatPropertyLimitWritingLimitsEditTool.vue?vue&type=template&id=4ef9f470&scoped=true&"
import script from "./FormatPropertyLimitWritingLimitsEditTool.vue?vue&type=script&lang=ts&"
export * from "./FormatPropertyLimitWritingLimitsEditTool.vue?vue&type=script&lang=ts&"
import style0 from "./FormatPropertyLimitWritingLimitsEditTool.vue?vue&type=style&index=0&id=4ef9f470&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ef9f470",
  null
  
)

export default component.exports